import { Metamodel } from 'app/model/base/model';
import { XmlDataset } from 'app/model/dataset/xml.dataset';
import { FormatReadSettings } from './format-read-settings';

import { IAttribute, IViolation } from 'app/model/base/annotation';
import { IComplexKeyValPair } from 'app/interfaces/IComplexKeyValPair';
import { CopyActivity } from '../../copy.activity';
import { XmlCopySource } from '../xml.copysource';
import { BlobTypeStoreReadSettings } from '../store-read-settings/blob-type-store-read-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.xml.formatRead,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(XmlDataset) }
})
export class XmlFormatReadSettings extends FormatReadSettings {
    public static readonly VALIDATION_MODE: IAttribute;
    public static readonly NAMESPACES: IAttribute;
    public static readonly NAMESPACE_PREFIXES: IAttribute;
    public static readonly DETECT_DATA_TYPE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'VALIDATION_MODE',
        display: stringResources.DataFlowSourceSettingsValidationMode,
        constraint: {
            validator: XmlFormatReadSettings.validateValidationMode
        }
    })
    public validationMode: string = 'none';

    @Metamodel.attribute({
        templatable: true,
        association: 'NAMESPACES',
        display: stringResources.DataFlowSourceSettingsNamespaces
    })
    public namespaces: boolean = true;

    @Metamodel.attribute({
        templatable: true,
        association: 'NAMESPACE_PREFIXES',
        display: stringResources.DataFlowSourceSettingsNamepsacePrefixes
    })
    public namespacePrefixes: Array<IComplexKeyValPair<string, string>>;

    @Metamodel.attribute({
        templatable: true,
        association: 'DETECT_DATA_TYPE',
        display: stringResources.DataFlow_DetectDataType
    })
    public detectDataType?: boolean;

    public static validateValidationMode(formatSettings: XmlFormatReadSettings): IViolation[] | undefined {
        if (formatSettings.owner && formatSettings.owner.owner && formatSettings.owner.owner instanceof CopyActivity) {
            const source = formatSettings.owner as XmlCopySource;
            if (
                formatSettings.validationMode &&
                formatSettings.validationMode !== 'none' &&
                source.storeSettings instanceof BlobTypeStoreReadSettings &&
                source.storeSettings.maxConcurrentConnections
            ) {
                return [
                    {
                        message: () =>
                            stringResources.Xml_ValidationMode_InCompatible_With_MaxConcurrentConnection_Error,
                        redirectTo: {
                            attribute: XmlFormatReadSettings.VALIDATION_MODE,
                            entity: formatSettings
                        }
                    }
                ];
            }
        }
        return undefined;
    }
}
